import { HStack, Text, TextProps } from '@chakra-ui/react'

import { TrendArrow } from '../../components/trends/TrendArrow'
import { createWidget } from '../widget-utils'

export interface DeltaTrendWidgetProps {
  amount?: number
  delta?: number
  amountStyling?: TextProps
  deltaStyling?: TextProps
  suffix?: string
}

export const DeltaTrendWidget = ({
  amount,
  delta,
  amountStyling,
  deltaStyling,
  suffix,
  ...props
}: DeltaTrendWidgetProps) => {
  return (
    <HStack {...props} pr="8px" spacing="16px">
      {typeof amount === 'number' && (
        <HStack gap="8px" alignItems="baseline">
          <Text
            fontSize="32px"
            lineHeight="1.1em"
            color="presets.turquoise.100"
            {...amountStyling}
          >
            {amount}
          </Text>
          {suffix && (
            <Text fontSize="20px" color="presets.turquoise.100">
              {suffix}
            </Text>
          )}
        </HStack>
      )}
      {typeof delta === 'number' && (
        <HStack alignItems="flex-end" gap="5px">
          <TrendArrow value={delta} />
          <Text
            color="presets.turquoise.100"
            fontSize="14px"
            lineHeight="14px"
            fontWeight="medium"
            {...deltaStyling}
          >
            {delta && delta > 0
              ? `+${delta}`
              : `${delta !== null ? delta : ''}`}
          </Text>
        </HStack>
      )}
    </HStack>
  )
}

export const DeltaTrendWidgetDefinition = createWidget(DeltaTrendWidget, {
  type: 'DeltaTrend',
})
